import information from '@/views/mainContentCentral/information'

import standardManage from '@/views/mainContentCentral/information/standardManage'

import standardManageOrganization from '@/views/mainContentCentral/information/standardManage/organization'

import legal from '@/views/mainContentCentral/information/standardManage/organization/legal'
import system from '@/views/mainContentCentral/information/standardManage/organization/system'
import system1 from '@/views/mainContentCentral/information/standardManage/organization/system1'
import team from '@/views/mainContentCentral/information/standardManage/organization/team'

import goods from '@/views/mainContentCentral/information/standardManage/goods'

import goodsselect from '@/views/mainContentCentral/information/standardManage/goods/goodsselect'
import goodslogin from '@/views/mainContentCentral/information/standardManage/goods/goodslogin'
import goodsprotect from '@/views/mainContentCentral/information/standardManage/goods/goodsprotect'
import goodsbg from '@/views/mainContentCentral/information/standardManage/goods/goodsbg'

import open from '@/views/mainContentCentral/information/standardManage/open'
import infomations from '@/views/mainContentCentral/information/standardManage/open/infomations'
import visit from '@/views/mainContentCentral/information/standardManage/open/visit'

import safety from '@/views/mainContentCentral/information/standardManage/safety'
import realize from '@/views/mainContentCentral/information/standardManage/safety/realize'
import goodssafety from '@/views/mainContentCentral/information/standardManage/safety/goods'
import publics from '@/views/mainContentCentral/information/standardManage/safety/public'
import info from '@/views/mainContentCentral/information/standardManage/safety/info'


import service from '@/views/mainContentCentral/information/service'
import science from '@/views/mainContentCentral/information/service/science'
import output from '@/views/mainContentCentral/information/service/science/output'
import service1 from '@/views/mainContentCentral/information/service/science/service'


import list from '@/views/mainContentCentral/information/service/list'
import base from '@/views/mainContentCentral/information/service/list/base'
import shorttime from '@/views/mainContentCentral/information/service/list/shorttime'

import teac from '@/views/mainContentCentral/information/service/teac'
import explain from '@/views/mainContentCentral/information/service/teac/explain'
import exercise from '@/views/mainContentCentral/information/service/teac/exercise'
import appraisal from '@/views/mainContentCentral/information/service/teac/appraisal'


import culture from '@/views/mainContentCentral/information/service/culture'
import communication from '@/views/mainContentCentral/information/service/culture/communication'
import communicate from '@/views/mainContentCentral/information/service/culture/communicate'
import numbers from '@/views/mainContentCentral/information/service/culture/number'
import management from '@/views/mainContentCentral/information/service/culture/management'

import society from '@/views/mainContentCentral/information/society'
import audience from '@/views/mainContentCentral/information/society/audience'
import structure from '@/views/mainContentCentral/information/society/audience/structure'
import Satisfaction from '@/views/mainContentCentral/information/society/audience/Satisfaction'

import influence from '@/views/mainContentCentral/information/society/influence'
import follow from '@/views/mainContentCentral/information/society/influence/follow'
import reward from '@/views/mainContentCentral/information/society/influence/reward'
import participate from '@/views/mainContentCentral/information/society/influence/participate'

import special from '@/views/mainContentCentral/information/special'
import cut from '@/views/mainContentCentral/information/cut'
import synthesize from '@/views/mainContentCentral/information/synthesize'
import enclosure from '@/views/mainContentCentral/information/enclosure'
import download from '@/views/mainContentCentral/information/download'
import basemenu from '@/views/mainContentCentral/information/base'

import museumperson from '@/views/mainContentCentral/user'
import addmuseumperson from '@/views/mainContentCentral/user/listNew'

import specialist from '@/views/mainContentCentral/specialist'

import addspecialist from '@/views/mainContentCentral/specialist/listNew'

import country from '@/views/mainContentCentral/country'
import addcountry from '@/views/mainContentCentral/country/listNew'
import province from '@/views/mainContentCentral/province'
import addprovince from '@/views/mainContentCentral/province/listNew'
import pftj from '@/views/mainContentCentral/statisticalQuery/pftj'
import museum from '@/views/mainContentCentral/statisticalQuery/museum'
import pfcx from '@/views/mainContentCentral/statisticalQuery/pfcx'
import progress from '@/views/mainContentCentral/processManagement'
import addaudit from '@/views/mainContentCentral/audit/addaudit'
import cutaudit from '@/views/mainContentCentral/audit/cutaudit'
import scoreadjust from '@/views/mainContentCentral/audit/scoreadjust'
import personinfo from '@/views/mainContentCentral/personinfo'
import ranking from '@/views/mainContentCentral/statisticalQuery/ranking'
import addmuseumadminCentral from '@/views/mainContentCentral/museumadminCentral/listNew'
import museumadminCentral from '@/views/mainContentCentral/museumadminCentral'
import libraryUser from '@/views/mainContentCentral/libraryUser'
import editlibraryUser from '@/views/mainContentCentral/libraryUser/listNew/index'
import fillprogressCentral from '@/views/mainContentCentral/statisticalQuery/fillprogressCentral'
import scoreprogressCentral from '@/views/mainContentCentral/statisticalQuery/scoreprogressCentral'
import performance from '@/views/mainContentCentral/information/performance'
import tabledatas from "../views/mainContentCentral/statisticalQuery/tabledata";
let standardManageRouter = {
  path: '/informationDeclarationCentral',
  component: information,
  exact: true,
  children: [
    {
      path: '/informationDeclaration/museumbaseinfoCentral',
      component: basemenu,
      exact: true,
    },
    {
      path: '/standardManageCentral',
      component: standardManage,
      exact: true,
      children:[
        {
          path: '/informationDeclaration/standardManage/organizationCentral',
          component: standardManageOrganization,
          exact: true,
          children:[
            {
              path: '/informationDeclaration/standardManage/organization/legalCentral',
              component: legal,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/organization/systemCentral',
              component: system,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/organization/system1Central',
              component: system1,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/organization/teamCentral',
              component: team,
              exact: true,
            },
          ]
        },
        {
          path: '/informationDeclaration/standardManage/goodsCentral',
          component: goods,
          exact: true,
          children:[
            {
              path: '/informationDeclaration/standardManage/goods/goodsselectCentral',
              component: goodsselect,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/goods/goodsloginCentral',
              component: goodslogin,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/goods/goodsbgCentral',
              component: goodsbg,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/goods/goodsprotectCentral',
              component: goodsprotect,
              exact: true,
            },
          ]
        },
        {
          path: '/informationDeclaration/standardManage/openCentral',
          component: open,
          exact: true,
          children:[
            {
              path: '/informationDeclaration/standardManage/open/infomationsCentral',
              component: infomations,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/open/visitCentral',
              component: visit,
              exact: true,
            },
          ]
        },
        {
          path: '/informationDeclaration/standardManage/safetyCentral',
          component: safety,
          exact: true,
          children:[
            {
              path: '/informationDeclaration/standardManage/safety/realizeCentral',
              component: realize,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/safety/goodsCentral',
              component: goodssafety,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/safety/publicCentral',
              component: publics,
              exact: true,
            },
            {
              path: '/informationDeclaration/standardManage/safety/infoCentral',
              component: info,
              exact: true,
            },
          ]
        },
      ]
    },
    {
      path: '/informationDeclaration/serviceCentral',
      component: service,
      exact: true,
      children:[
        {
          path: '/informationDeclaration/service/scienceCentral',
          component: science,
          exact: true,
          children:[
            {
              path: '/informationDeclaration/service/science/outputCentral',
              component: output,
              exact: true,
            },
            {
              path: '/informationDeclaration/service/science/serviceCentral',
              component: service1,
              exact: true,
            },
          ]
        },
        {
          path: '/informationDeclaration/service/listCentral',
          component: list,
          exact: true,
          children:[
            {
              path: '/informationDeclaration/service/list/baseCentral',
              component: base,
              exact: true,
            },
            {
              path: '/informationDeclaration/service/list/shorttimeCentral',
              component: shorttime,
              exact: true,
            },
          ]
        },
        {
          path: '/informationDeclaration/service/teacCentral',
          component: teac,
          exact: true,
          children:[
            {
              path: '/informationDeclaration/service/teac/explainCentral',
              component: explain,
              exact: true,
            },
            {
              path: '/informationDeclaration/service/teac/exerciseCentral',
              component: exercise,
              exact: true,
            },
            {
              path: '/informationDeclaration/service/teac/appraisalCentral',
              component: appraisal,
              exact: true,
            },
          ]
        },
        {
          path: '/informationDeclaration/service/cultureCentral',
          component: culture,
          exact: true,
          children:[
            {
              path: '/informationDeclaration/service/culture/communicationCentral',
              component: communication,
              exact: true,
            },
            {
              path: '/informationDeclaration/service/culture/communicateCentral',
              component: communicate,
              exact: true,
            },
            {
              path: '/informationDeclaration/service/culture/numberCentral',
              component: numbers,
              exact: true,
            },
            {
              path: '/informationDeclaration/service/culture/managementCentral',
              component: management,
              exact: true,
            },
          ]
        },
      ]
    },
    {
      path: '/informationDeclaration/societyCentral',
      component: society,
      exact: true,
      children:[
        {
          path: '/informationDeclaration/society/audienceCentral',
          component: audience,
          exact: true,
          children:[
            {
              path: '/informationDeclaration/society/audience/structureCentral',
              component: structure,
              exact: true,
            },
            {
              path: '/informationDeclaration/society/audience/SatisfactionCentral',
              component: Satisfaction,
              exact: true,
            },
          ]
        },
        {
          path: '/informationDeclaration/society/influenceCentral',
          component: influence,
          exact: true,
          children:[
            {
              path: '/informationDeclaration/society/influence/followCentral',
              component: follow,
              exact: true,
            },
            {
              path: '/informationDeclaration/society/influence/rewardCentral',
              component: reward,
              exact: true,
            },
            {
              path: '/informationDeclaration/society/influence/participateCentral',
              component: participate,
              exact: true,
            },
          ]
        },
      ]
    },
    {
      path: '/informationDeclaration/addition/specialCentral',
      component: special,
      exact: true,
    },
    {
      path: '/informationDeclaration/enclosureCentral',
      component: enclosure,
      exact: true,
    },
    {
      path: '/informationDeclaration/downloadCentral',
      component: download,
      exact: true,
    },
    {
      path: '/expert/museumgroupCentral',
      component: museumperson,
      exact: true,
    },
    {
      path: '/expert/addmuseumpersonCentral',
      component: addmuseumperson,
      exact: true,
    },
    {
      path: '/expert/specialistCentral',
      component: specialist,
      exact: true,
    },
    {
      path: '/informationDeclaration/addition/warningCentral',
      component: cut,
      exact: true,
    },
    {
      path: '/informationDeclaration/addition/proposalCentral',
      component: synthesize,
      exact: true,
    },
    {
      path: '/expert/addspecialistCentral',
      component: addspecialist,
      exact: true,
    },
    {
      path: '/person/userCentral',
      component: country,
      exact: true,
    },
    {
      path: '/person/addcountryCentral',
      component: addcountry,
      exact: true,
    },
    {
      path: '/person/provinceCentral',
      component: province,
      exact: true,
    },
    {
      path: '/informationDeclaration/addprovinceCentral',
      component: addprovince,
      exact: true,
    },
    {
      path: '/query/statCentral',
      component: pftj,
      exact: true,
    },
    {
      path: '/query/museumCentral',
      component: museum,
      exact: true,
    },
    {
      path: '/query/scoreCentral',
      component: pfcx,
      exact: true,
    },
    {
      path: '/progressCentral',
      component: progress,
      exact: true,
    },
    {
      path: '/confirm/addauditCentral',
      component: addaudit,
      exact: true,
    },
    {
      path: '/confirm/cutauditCentral',
      component: cutaudit,
      exact: true,
    },
    {
      path: '/confirm/scoreadjustCentral',
      component: scoreadjust,
      exact: true,
    },
    {
      path: '/personinfo',
      component: personinfo,
      exact: true,
    },
    {
      path: '/query/rankingCentral',
      component: ranking,
      exact: true,
    },
    {
      path: '/person/museumadminCentral',
      component: libraryUser,
      exact: true,
    },
    {
      path: '/libraryuser/addcountryCentral',
      component: editlibraryUser,
      exact: true,
    },
    {
      path: '/person/addmuseumadminCentral',
      component: addmuseumadminCentral,
      exact: true,
    },
    {
      path: '/query/fillprogressCentral',
      component: fillprogressCentral,
      exact: true,
    },
    { //其他文件
      path: '/informationDeclaration/jxdcbCentral',
      component: performance,
      exact: true,
    },
  ]
}
function computedData(data){
  data.forEach(item=>{
      if (item.name === '查询统计'){
      if (item.children) {
        item.children.forEach(item1=>{
          if (item1.type === 'tables'){
            standardManageRouter.children.push(
                { //基本信息
                  path: item1.rule,
                  component: tabledatas,
                  exact: true,
                },
            )
          }
          if (item1.children){
            item1.children.forEach(item2=>{
              if (item2.type === 'tables'){
                standardManageRouter.children.push(
                    { //基本信息
                      path: item2.rule,
                      component: tabledatas,
                      exact: true,
                    },
                )
              }
            })
          }
        })
      }
    }
  })
}
const login = localStorage.getItem('login')
if (login) {
  var menu = JSON.parse(localStorage.getItem('userList')).menulist
  if (menu && menu.length > 0) {
    computedData(menu)
  }
}
export default standardManageRouter
